"use strict";

/* Crosshairs manager*/
(function (H) {
	var ChangeCrossHairDateFormatInterval = ['1d','1w','1month'];
	var csAttr = {
		stroke: isDarkMode == true ? '#757575' : '#524f4f',
		'stroke-width': 1,
		dashstyle: 'LongDash',
		zIndex: 6
	},
	    labelsCss = {
		'position': 'absolute',
		'text-align': 'center',
		'background-color': '#DADADA',
		'font-size': '0.8em',
		'z-index': '11'
	},
	    xLabelOffset = 10,
	    drawCrosshairs = function drawCrosshairs(chart, _options) { /*CROSSHAIRS FUNCTION*/

			//csAttr.class = 'crossHairLine';

			var _csAttr1 = csAttr, //merge(csAttr, _options.style),
				lcss = merge(labelsCss, _options.labels.style),
				xLabel = $('<div class="xLabelDrag"></div>').css(lcss).css({ 'right': '-2px' }).hide(),
				xLabel2 = $('<div class="xLabelDrag2"></div>').css(lcss).css({ 'left': '-2px' }).hide(),
				yLabel = $('<div class="yLabelDrag"></div>').css(lcss).css({ 'bottom': '5px', 'padding': '5px 6px' }).hide();


			var isFullScreen = document.fullscreenElement || document.msFullscreenElement || document.mozFullScreen || document.webkitIsFullScreen;
				isFullScreen = isFullScreen ? true : false;

			var crossHairHeight = (screen.height * 20) / 100;

			chart.myCrosshairs = {
				hidden: true,
				x: chart.renderer.path(['M', chart.plotLeft, 0, 'L', chart.plotLeft + screen.width, 0]).attr(_csAttr1).add().toFront().hide().addClass("crosshair-fix-horizontal"),
				y: chart.renderer.path(['M', 0, chart.plotTop, 'L', 0, chart.plotTop + screen.height /*- crossHairHeight*/ /*chart.plotHeight*/]).attr(_csAttr1).add().toFront().hide().addClass("crosshair-fix-vertical"),	
				xLabel: xLabel,
				xLabel2: xLabel2,
				yLabel: yLabel,
				destroy: function destroy() {
					this.x.destroy();
					this.y.destroy();
					this.xLabel.remove();
					this.xLabel2.remove();
					this.yLabel.remove();
				},
				hide: function hide() {
					if (this.hidden) {
						return;
					}
					this.x.hide();
					this.y.hide();
					this.xLabel.hide();
					this.xLabel2.hide();
					this.yLabel.hide();
					this.hidden = true;
				},
				show: function show() {
					if (!this.hidden) {
						return;
					}
					this.x.show();
					this.y.show();
					this.xLabel.show();
					this.xLabel2.show();
					this.yLabel.show();
					this.hidden = false;
				}
			};

			$(chart.container).append(xLabel).append(xLabel2).append(yLabel);
		};

	/**
	 * draw X and Y cross, bind events to mousemove
	 */
	 H.wrap(H.Chart.prototype, 'init', function (proceed) {
		proceed.apply(this, Array.prototype.slice.call(arguments, 1));

		var mouseDown = false;
		var chart = this,
		    options = chart.options;

		if (options.myCrosshairs || !options.crosshairs || !options.crosshairs.enabled) {
			return;
		}

		drawCrosshairs(chart, options.crosshairs || {});

				//ACTION TO DRAW A HORIZONTAL LINE
				$(chart.container).on('click', function (e) {
					if($(".draw-horizontalline-active").is(":visible")){
						var offset = $(chart.container).offset(),
								offsetY = e.pageY - offset.top,
								yE = _th.chart.yAxis[0].getExtremes(),
								xE = _th.chart.xAxis[0].getExtremes();
						var plotY = yE.max + yE.min - _th.chart.yAxis[0].translate(offsetY - _th.chart.plotTop, true);
						HVlineAnnotation(plotY , xE, 'horizontalLine')
						$('#iChartHeader-annotationPicker-button').removeClass("draw-horizontalline-active")
						$('.iChart-chart').css('cursor','default')	
						$("#control-bar-wrapper").css("display","block")
					}
					if($(".draw-verticalline-active").is(":visible")){
						var offset = $(chart.container).offset(),
								yE = _th.chart.yAxis[0].getExtremes();
		
						HVlineAnnotation(yE,chart.hoverPoint.x, 'verticalLine')
						$('#iChartHeader-annotationPicker-button').removeClass("draw-verticalline-active")
						$('.iChart-chart').css('cursor','default')	
						$("#control-bar-wrapper").css("display","block")
					}
		});

		$(chart.container).on('mouseleave .crosshairs', function () {
			mouseDown = false;
			chart.myCrosshairs.hide();
			$('#iChartHeader-annotationPicker-button').removeClass("draw-horizontalline-active")
			$('#iChartHeader-annotationPicker-button').removeClass("draw-verticalline-active")
			$('#iChartHeader-annotationPicker-button').removeClass("draw-trendline-active")
			$('#iChartHeader-annotationPicker-button').removeClass("draw-textannotation-active")
			if ($('.textannotation-popup-title').is(":visible") === false) {
				$("#control-bar-wrapper").css("display","block")
			}
			$('.iChart-chart').css('cursor','default')
		});

		$(chart.container).on('mousedown', function (e) {
			mouseDown=true;

			$(chart.container).on('mousemove.crosshairs', function (e) {
					chart.myCrosshairs.show();
			
				if(mouseDown == true){
					var cs = chart.myCrosshairs,
						offset = $(chart.container).offset(),
						offsetX = e.pageX - offset.left,
						offsetY = e.pageY - offset.top;

					if (!cs) {
						return;
					}

					if (chart.isInsidePlot(offsetX - chart.plotLeft, offsetY - chart.plotTop)){
						cs.show();
					} else {
						cs.hide();
					}
				}
			});
		});

		$(chart.container).on('mouseup', function (e) { mouseDown = false;});
		if (mouseDown == false) {

			$(chart.container).on('mousemove.crosshairs', function (e) {
				//RE-ORDER ANNOTATION AND CONTROL POINTS POSITION, CROSSHAIRS WAS MESSING WITHT HE FEATURES OF THIS
				if($(".highcharts-control-points")[0].previousElementSibling.classList[0] != 'highcharts-annotation'){
						$( ".highcharts-annotation" ).before( $(".highcharts-control-points"));
						$( ".highcharts-control-points" ).before( $(".highcharts-annotation"));
				}
				chart.myCrosshairs.show();
				
				var cs = chart.myCrosshairs,
					offset = $(chart.container).offset(),
					offsetX = e.pageX - offset.left,

					offsetY = e.pageY - offset.top;
					var xAxis = chart.get('mainX'),
						yAxis = chart.yAxis[0],
						yAxis2 = chart.yAxis[2] ? chart.yAxis[2] : null;

					if (!cs) {
						return;
					}

					if (chart.isInsidePlot(offsetX - chart.plotLeft, offsetY - chart.plotTop)){
						cs.show();
					} else {
						cs.hide();
					}

					if (!cs.hidden) {

						cs.x.translate(0, offsetY);
						cs.y.translate(offsetX, 0);
						if(chart.hoverPoint){
							e = chart.pointer.normalize(e);
							var eValue = yAxis.toValue(e.chartY, 0);
							var eValue2 = yAxis2 ? yAxis2.toValue(e.chartY, 0) : null;
							var x = chart.hoverPoint.x;
							var onHoverYaxisCenter = 75;
							var dateTimeFormat = "%b %d %Y - %H:%M";
							try{
								if(_th.config.cdata.interval && ChangeCrossHairDateFormatInterval.indexOf(_th.config.cdata.interval.toString()) != -1) {
									dateTimeFormat = "%b %d %Y";
									onHoverYaxisCenter = 45;
									if(thisInterval === '1month'){
										onHoverYaxisCenter = 40
									}
								}
							}catch(err){ console.log("Interval Error: ", err) }

							//MOVES X LABELS OF CROSSHAIR
							if(offsetX < 100 && chart.series.length < 3){
								onHoverYaxisCenter = 0;
							}else if(offsetX < 150 && chart.series.length > 2){
								onHoverYaxisCenter = 0;
							}

							if(!isFS && !isMobile){							
								if(offsetX > 600){
									if(dateTimeFormat == '%b %d %Y - %H:%M'){
										onHoverYaxisCenter = 155;
									}else if(thisInterval === '1month'){
										onHoverYaxisCenter = 78
									}
									else{
										onHoverYaxisCenter = 100;
									}
								}
							}else if(isMobile && !isFS){
								if(offsetX > (chart.plotSizeX - 70)){
									if(dateTimeFormat == '%b %d %Y - %H:%M'){
										onHoverYaxisCenter = 148;
									}else if(thisInterval === '1month'){
										onHoverYaxisCenter = 72
									}
									else{
										onHoverYaxisCenter = 93;
									}
								}
							}else{
							if(offsetX > $(window).width()-150){
								if(dateTimeFormat == '%b %d %Y - %H:%M'){
									onHoverYaxisCenter = 155;
								}else if(thisInterval === '1month'){
									onHoverYaxisCenter = 78
								}else{
									onHoverYaxisCenter = 100;
								}
							}
							}

							var dragLabel = H.dateFormat(xAxis.options.csLabelFormat || dateTimeFormat, x)
							if(thisInterval === '1month'){
								dragLabel = dragLabel.split(" ")
								dragLabel.splice(1,1)
								dragLabel = dragLabel.join(" ")
							}

							chart.myCrosshairs.yLabel.css({
								left: offsetX - onHoverYaxisCenter,
								marginBottom: -1
							}).html(dragLabel); //Crosshair Change DateTime Format

							if (eValue)
							{
					
								//var val = Number(parseFloat(eValue).toFixed(4))
								
								if((eValue < 0.0010 && eValue > 0) ||(eValue > -1 && eValue < 0)){
									var val = Number(parseFloat(eValue).toFixed(6))							
								}else{	
								var val = Number(parseFloat(eValue).toFixed(4))
							}

								if (eValue > 1) {
									val = parseFloat(val).toFixed(4)
								}
								if (eValue > 10) {
									val = parseFloat(val).toFixed(3)
								}
								if (eValue > 100) {
									val = parseFloat(val).toFixed(2)
								}
								if (eValue > 1000) {
									val = parseFloat(val).toFixed(1)
								}
								chart.myCrosshairs.xLabel.css({
									top: offsetY - xLabelOffset,
									width: chart.chartWidth - chart.plotWidth - chart.plotLeft,
								}).html(val);
							}
							else chart.myCrosshairs.xLabel.css('display', 'none');

							if (eValue2)
							{
								var val = Number(parseFloat(eValue2))

								if((eValue2 < 0.0010 && eValue2 > 0)||(eValue2 > -1 && eValue2 < 0)){
									val = Number(parseFloat(eValue2).toFixed(6))							
								}else{
									val = Number(parseFloat(eValue2).toFixed(4))
								}

								if (eValue2 > 1) {
									val = Number(parseFloat(val).toFixed(4))
								}
								if (eValue2 > 10) {
									val = Number(parseFloat(val).toFixed(3))
								}
								if (eValue2 > 100) {
									val = Number(parseFloat(val).toFixed(2))
								}
								if (eValue2 > 1000) {
									val = Number(parseFloat(val).toFixed(1))
								}


								chart.myCrosshairs.xLabel2.css({
									top: offsetY - xLabelOffset,
									width: chart.chartWidth - chart.plotWidth - chart.plotLeft
								}).html(val);
							}
							else chart.myCrosshairs.xLabel2.css('display', 'none');
						}
					}
			});
		}
	});

	var pointsObj = {}

	H.wrap(H.Tooltip.prototype, 'refresh', function (proceed, point, e) {


		proceed.apply(this, Array.prototype.slice.call(arguments, 1));

		if (Array.isArray(point)) {

			for (var i in point) {
				if(point[i].series.userOptions.type != "sma"){
					var pointStr = point[i].series.userOptions.id;
					if (pointStr.indexOf('null') < 0 ){
						pointsObj[pointStr] = point[i];
					}
				}
				}
		} else if(point.series.userOptions.type.toLowerCase() == 'flags') {
			var pointStr = point.series.userOptions.id;
			if (pointStr.indexOf('null') < 0 ){
				pointsObj[pointStr] = point[i];
			}
		}

		if (e) {
			var chart = this.chart;
			if (chart.myCrosshairs && point[0]) {
				if (chart.bodyLabelsHook) chart.bodyLabelsHook(point[0], pointsObj);
			}
		}
	});
})(Highcharts);